import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {TkColor} from '../../enums/core/tk-color';
import {IonicModule} from '@ionic/angular';
import {RouterLink} from '@angular/router';
import {NgStyle, NgTemplateOutlet} from '@angular/common';

@Component({
  standalone: true,
  selector: 'tk-std-toolbar',
  templateUrl: './std-toolbar.component.html',
  styleUrls: ['./std-toolbar.component.scss'],
  imports: [
    IonicModule,
    RouterLink,
    NgStyle,
    NgTemplateOutlet
  ]
})
export class StdToolbarComponent implements OnInit {

  @Input() color: string = TkColor.Primary;
  @Input() bgColor: string = TkColor.PrimaryBg;
  @Input() lighten: number = 0.65;
  @Input() backButtonRouterLink: string = null;
  @Input() backButton: boolean = false;
  @Input() title: string | TemplateRef<any> = null;
  @Input() subtitle: string = null;
  @Input() subtitleTemplate: TemplateRef<any> = null;
  @Input() startTemplate: TemplateRef<any> = null;
  @Input() endTemplate: TemplateRef<any> = null;
  @Input() closeable: boolean = false;
  @Input() withMenuButton: boolean = false;

  @Output() closeEvent: EventEmitter<void> = new EventEmitter<void>();

  protected isTitleTemplate: boolean = false;
  protected titleTemplate: TemplateRef<any>;

  constructor() {
  }

  public ngOnInit(): void {
    if(this.title instanceof TemplateRef) {
      this.isTitleTemplate = true;
      this.titleTemplate = this.title;
    }
  }

}
